"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _company = require("../../store/company");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastOpen,
    setToastText,
    setIsLoading,
    setLoadingMessage
  } = (0, _common.useCommonStore)();
  const {
    setCurrentCompany,
    checkCurrentCompany,
    addCurrentCompany,
    updateCurrentCompany,
    setCurrentCompanyById,
    initCurrentCompany,
    currentCompany,
    errors,
    submitting
  } = (0, _company.useCompanyStore)();
  console.log("id");
  console.log(currentCompany.id);
  const licenceCodeRef = (0, _react.useRef)(null);
  const adminEmailRef = (0, _react.useRef)(null);
  const isEnableRef = (0, _react.useRef)(null);
  const submitButtonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    (async () => {
      if (!props.id) {
        initCurrentCompany();
        return;
      }
      setIsLoading(true);
      await setCurrentCompanyById(props.id);
      setIsLoading(false);
    })();
  }, []);
  const onLoadingTextChanged = text => {
    setLoadingMessage(text);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {
          setLocation('/companies');
        },
        children: "\uFF1C\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u4F01\u696D\u8FFD\u52A0"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u4F01\u696D\u540D",
        type: "text",
        value: currentCompany.name,
        errorText: errors.name,
        placeholder: '企業の名前を入力してください(他の企業と重複不可)',
        onChange: event => {
          setCurrentCompany({
            name: event.target.value
          });
        },
        onEnterKey: () => {
          var _licenceCodeRef$curre;
          (_licenceCodeRef$curre = licenceCodeRef.current) === null || _licenceCodeRef$curre === void 0 ? void 0 : _licenceCodeRef$curre.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30E9\u30A4\u30BB\u30F3\u30B9\u30B3\u30FC\u30C9",
        ref: licenceCodeRef,
        type: "text",
        value: currentCompany.licenceCode,
        errorText: errors.licenceCode,
        placeholder: 'ライセンスコードを入力してください)',
        onChange: event => {
          setCurrentCompany({
            licenceCode: event.target.value
          });
        },
        onEnterKey: () => {
          var _adminEmailRef$curren;
          (_adminEmailRef$curren = adminEmailRef.current) === null || _adminEmailRef$curren === void 0 ? void 0 : _adminEmailRef$curren.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldCheckbox, {
        label: "\u6709\u52B9/\u7121\u52B9",
        ref: isEnableRef,
        type: "checkbox",
        checked: currentCompany.isEnable,
        errorText: errors.isEnable,
        placeholder: '有効にする',
        onChange: event => {
          const target = event.target;
          setCurrentCompany({
            isEnable: target.checked
          });
        },
        onEnterKey: () => {
          var _submitButtonRef$curr;
          (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : _submitButtonRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        ref: submitButtonRef,
        onClick: async () => {
          setIsLoading(true);
          if (!props.id) {
            setLocation('/companies');
            setToastText('企業IDが不正です');
            setToastOpen(true);
            return;
          }
          if (!(await checkCurrentCompany(true))) {
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          if (!window.confirm('企業内容を変更しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = await updateCurrentCompany(onLoadingTextChanged);
          if (!result) {
            setIsLoading(false);
            return;
          }
          setToastOpen(true);
          setToastText('企業内容を変更しました');
          setLocation('/companies');
          setIsLoading(false);
          return;
        },
        children: submitting ? '企業内容変更中...' : '企業内容を変更する'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;